export default {
    methods: {
        isNotEmpty: function (val) {
            return (val != undefined && val != null && val.length > 0);
        },
        isValidPassword: function (val) {
            return (val != undefined && val != null && val.length > 5);
        },
        isValidTerms: function (val) {
            return (val);
        },
        isValidCellNumber: function (val) {
            return (/^\d{10}$/.test(val));
        },
        isValidEmail: function (email) {
            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).trim().toLowerCase());
        },
        isValidIdNumber: function (idNumber) {
            return (val != undefined && val != null && val.length == 13);
        },
    }
}
